'use strict'

import '@fancyapps/fancybox'
import 'bootstrap'
import Click from './Components/Click'
import Menu from './Components/Menu'
import ProductBack from './Components/ProductBack'
import TtProducts from './Components/TtProducts'

export default class Application {
  constructor() {
    this
      ._initializeClick()
      ._initializeMenu()
      ._initializeProductBack()
      ._initializeTtProducts()

    return this
  }

  _initializeClick() {
    (() => new Click())()

    return this
  }

  _initializeMenu() {
    (() => new Menu())()

    return this
  }

  _initializeProductBack() {
    (() => new ProductBack())()

    return this
  }

  _initializeTtProducts() {
    (() => new TtProducts())()

    return this
  }
}
